var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0L22.8923 6V18L12.5 24L2.1077 18V6L12.5 0Z",
    fill: "#FF3C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8414 8.23251C9.05441 8.0195 9.39978 8.0195 9.61279 8.23251L12.4998 11.1195L15.3869 8.23251C15.5999 8.0195 15.9452 8.0195 16.1582 8.23251C16.3713 8.44553 16.3713 8.79089 16.1582 9.0039L13.2712 11.8909L16.1582 14.778C16.3713 14.991 16.3713 15.3363 16.1582 15.5494C15.9452 15.7624 15.5999 15.7624 15.3869 15.5494L12.4998 12.6623L9.61279 15.5494C9.39978 15.7624 9.05441 15.7624 8.8414 15.5494C8.62839 15.3363 8.62839 14.991 8.8414 14.778L11.7284 11.8909L8.8414 9.0039C8.62839 8.79089 8.62839 8.44553 8.8414 8.23251Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.34230a1bd2323ffb69837324f3cfb251.svg";
export { ForwardRef as ReactComponent };